import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { EditActivityModal, Dialog } from 'components/modals'
import { Overview } from 'components/misc'
import { MaterialControlBar, DashboardGrid as Grid } from 'components/layout'
import { apiConfiguration, apiDashboard, apiDownloadFile } from 'helpers/decorators/api'
import MODALS from 'constants/layout/modals'
import { modal } from 'helpers/decorators'
import { ACTIVITY_STATES } from 'constants/enums'
import { createGroupActivities } from 'helpers/selectors'
import { connect } from 'react-redux'
import { isAssessorManagementEnabledForActivity } from '../../../helpers/assessorHelper'

const intls = {
  true: {
    intlKey: 'label.discuss_activity_leader',
    defaultMessage:
      'If you are selecting more than one activity, please discuss this with you Award Leader first.'
  },
  false: {
    intlKey: 'label.cannot_add_activity',
    defaultMessage:
      'You can add maximum of 3 activities for this category. Please discuss this with your Award Leader.'
  }
}

const groupActivities = createGroupActivities()

@modal.trigger()
@apiDashboard.apiActivity()
@apiDashboard.apiAwards()
@apiConfiguration()
@apiDownloadFile()
@connect(({ api }) => ({
  dashboard: api.dashboard
}))
class ActivityOverview extends Component {
  static propTypes = {
    awards: PropTypes.object.isRequired,
    onGetOverview: PropTypes.func.isRequired,
    onOpen: PropTypes.func.isRequired,
    activityOverview: PropTypes.object,
    params: PropTypes.object,
    activity: PropTypes.object,
    isReadOnly: PropTypes.bool,
    dashboard: PropTypes.object
  }

  state = {
    canAdd: true
  }

  componentWillMount = async () => {
    const { params } = this.props

    if (params && params.activityId) {
      this.handleLoadOverview(params.activityId)
    }
  }

  componentWillUpdate(nextProps) {
    const { params } = this.props

    if (
      get(params, 'activityId') &&
      get(params, 'activityId') !== get(nextProps.params, 'activityId')
    ) {
      this.handleLoadOverview(get(nextProps.params, 'activityId'))
    }
  }

  getOrgId() {
    return get(this.props, 'dashboard.awards.awards.data.organization.id')
  }

  handleLoadOverview = activityId => this.props.onGetOverview(activityId)

  handleOpenActivity = () => this.props.onOpen(MODALS.EDIT_ACTIVITY, null, null)

  handleAddActivity = () => {
    const activityId = get(this.props.activity, 'id')
    const activitySection = get(this.props.activity, 'activitySection')

    this.props.onOpen(null, null, null)
    // setTimeout because we need delay before opening next modal
    setTimeout(
      () =>
        this.props.onOpen(MODALS.ADD_ACTIVITY, null, {
          isAdditional: true,
          activityId,
          activity: { activitySection }
        }),
      300
    )
  }

  handleOpenConfirmation = () => {
    const groupedActivities = groupActivities(
      get(this.props.awards, 'activities', [])
    )

    const section = get(this.props.activity, 'activitySection.value')
    const activitiesCount = get(groupedActivities, `[${section}]`, []).length
    let canAdd = true

    if (activitiesCount >= 3) {
      canAdd = false
    }

    this.setState({ canAdd }, () =>
      this.props.onOpen(MODALS.CONFIRM_ACTIVITY, null, null)
    )
  }

  closeModal = () => this.props.onOpen(null, null, null)

  render() {
    const { activityOverview, activity, isReadOnly, currentAward } = this.props
    const { canAdd } = this.state
    const aim = get(activityOverview, 'data.aim')
    const startDate = get(activityOverview, 'data.startDate')
    const assessorName = get(activityOverview, 'data.assessor.person.name') || get(activityOverview, 'data.assessorName')
    const assessorEmail = get(activityOverview, 'data.assessor.person.email') || get(activityOverview, 'data.assessorEmail')
    const activitySection = get(activity, 'activitySection.value')
    const activityId = get(activity, 'id')
    const canEdit =
      ACTIVITY_STATES.in_progress.id ===
      get(activityOverview, 'data.activityState.value')

    const awardLevel = get(currentAward, 'awardLevel')

    let assessorDetailContent = [
      {
        id: '10',
        content: assessorName,
        intlKey: 'label.name',
        label: 'Name',
        ico: 'face'
      }
    ]

    const isAssessorManagementEnabled = isAssessorManagementEnabledForActivity(get(activityOverview, 'data'))

    if(!isAssessorManagementEnabled){
      assessorDetailContent.push( {
        id: '11',
        content: assessorEmail,
        intlKey: 'label.email',
        label: 'Email',
        ico: 'email'
      })
    }

    const assessorRegState = get(activity, 'assessorRegistrationState')


    if (isAssessorManagementEnabled) {
      assessorDetailContent.push({
        id: '12',
        content: assessorRegState,
        intlKey: 'label.assessor_state',
        label: 'Assessor state',
        ico: 'timer'
      })
    }

    return (
      <Grid.RightInner white>
        {canEdit &&
        !isReadOnly && (
          <MaterialControlBar
            edit={{
              onClick: this.handleOpenActivity,
              label: 'Edit Activity',
              intlKey: 'button.edit_activity'
            }}
            add={{
              onClick: this.handleOpenConfirmation,
              label: 'Add additional activity',
              intlKey: 'label.add_additional_activity'
            }}
          />
        )}
        <div className="row">
          <div className="col-xs-12 col-sm-6">
            <Overview
              activityOverview={activityOverview}
              activitySection={activitySection}
              title="Activity Detail"
              titleKey="moduleTitle.activity_details"
              content={[
                {
                  id: '00',
                  content: aim,
                  intlKey: 'label.goal',
                  label: 'Goal',
                  ico: 'flag'
                },
                {
                  id: '01',
                  content: startDate,
                  intlKey: 'label.start_date',
                  label: 'Start Date',
                  ico: 'date',
                  date: true
                }
              ]}
            />
          </div>
          <div className="col-xs-12 col-sm-6">
            <Overview
              activityOverview={activityOverview}
              activitySection={activitySection}
              title="Assessor Detail"
              titleKey="moduleTitle.assessor_details"
              content={assessorDetailContent}
            />
          </div>
        </div>

        <Dialog
          modalId={MODALS.CONFIRM_ACTIVITY}
          text={intls[canAdd]}
          confirmButton={{
            intlKey: canAdd ? 'button.add_activity' : 'button.ok',
            defaultMessage: canAdd ? 'ADD ACTIVITY' : 'OK',
            onClick: canAdd ? this.handleAddActivity : this.closeModal
          }}
          cancelButton={{
            intlKey: 'button.cancel',
            defaultMessage: 'Cancel',
            onClick: this.closeModal
          }}
        />

        <EditActivityModal
          modalId={MODALS.EDIT_ACTIVITY}
          params={this.props.params}
          activityId={activityId}
          awardLevel={awardLevel}
          activity={get(activityOverview, 'data')}
        />
      </Grid.RightInner>
    )
  }
}

export default ActivityOverview
